import React, { useCallback, useEffect, useId, useRef, useState } from "react";
import { openLiveChat, CHAT_ICON } from "./livechat"; // [2026-10-30] LINE -> แชทสด
import LangFlags from './langFlags';

export default function Navbar({ onNavigate, loginstate, rankpic, linelink }) {

  const handleNav = useCallback(

    (to) => (e) => {
      // อนุญาต Ctrl/Cmd/Shift/Alt/Middle click ให้ browser จัดการ
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
      e.preventDefault();
      console.log("5555", to)
      if (typeof onNavigate === "function") {
        onNavigate(to, e); // ✅ ใช้ onNavigate จาก props
      } else {
        // (fallback) เผื่อ parent ไม่ส่ง onNavigate มา
        window.history.pushState(null, "", to);
        window.dispatchEvent(new PopStateEvent("popstate"));
      }
    },
    [onNavigate]
  );


  const [modalx, setmodalx] = useState(false);
  const isHome = typeof window !== "undefined" && (window.location.pathname === "/" || window.location.pathname === "");
  console.log("loginstate", loginstate)
  return (
    <>

      <div className="container align-items-center h-100 position-relative">
        <div id="headerBrand">
          <a
            onClick={(e) => setmodalx(true)}
            className="btn navbar-brand"
            style={{
              cursor: "pointer",
              width: 20,
              color: "rgba(95, 117, 223, 0) !important"
            }}
          >
            <div
              onClick={(e) => setmodalx(true)}
              role="button"
              className="menu_icon"
              style={{ top: "-25px", left: "-15px" }}
            >
              <span className="one" />
              <span className="two" />
              <span className="three" />
            </div>
          </a>
          <div className="-branding-inner-wrapper">
            <a
              onClick={handleNav("/")}
              className="navbar-brand" role="button">
              <img
                src="/build/web/igame-index-lobby-wm/img/logo.png?v=1"
                className="w-logo-web-v22"
                alt=""
              />
            </a>
            {isHome && (
              <a
                onClick={(e) => { if (e && e.preventDefault) e.preventDefault(); window.open("/affiliate", "_blank"); }}
                role="button"
                title="สมัครพันธมิตร หารายได้กับเรา"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 4,
                  marginLeft: 8,
                  padding: "5px 12px",
                  borderRadius: 20,
                  fontSize: 13,
                  fontWeight: 800,
                  color: "#360000",
                  background: "linear-gradient(135deg,#ffe08a,#ffcf47)",
                  boxShadow: "0 3px 10px rgba(255,207,71,.45)",
                  whiteSpace: "nowrap",
                  cursor: "pointer"
                }}
              >
                💰 หารายได้
              </a>
            )}
          </div>
        </div>
        <div id="headerContent" style={{ display: loginstate ? "none" : "" }}>
          <ul className="nav -menu-wrapper -logged">
            {/**/}
            {/**/}
            {/**/}
            {/**/}
            {/**/}
          </ul>
          <div>
            <div className="navbar-nav">
              <div className="x-logged"  >
                <div className="-profile-container">
                  <div>
                    <div className="d-flex">

                      <div className="flex-fill" style={{ marginRight: "5px" }}>
                        <a
                          type="button"
                          onClick={handleNav("/register")}
                          style={{ cursor: "pointer" }}
                          className="register-auth p-2 pl-2-1 v-register"
                        >
                          สมัคร
                        </a>
                      </div>
                      <div className="flex-fill">
                        <a
                          type="button"
                          onClick={handleNav("/signin")}
                          style={{ cursor: "pointer" }}
                          className="login-auth p-2 pl-2-1 v-login"
                        >
                          เข้าสู่ระบบ
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/**/}
          </div>
        </div>
        <div id="headerContent" style={{ display: loginstate ? "" : "none" }}>
          <ul className="nav -menu-wrapper -logged">
            <li className="nav-item">
              <a
                onClick={handleNav("/refer/overview")}
                style={{ cursor: "pointer" }}
                className="nav-link -promotion" target="_self">
                <div className="-img-wrapper">
                  <img
                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/1b513b52-26e5-4fae-c268-9aa9cca5ad00/public"
                    className="-icon"
                    alt="Menu icon promotion"
                    width={30}
                    height={30}
                  />
                </div>
                <div className="-text">แนะนำเพื่อน</div>
              </a>
            </li>
            <li className="nav-item">
              <a onClick={(e) => { if (e && e.preventDefault) e.preventDefault(); window.open("/affiliate", "_blank"); }} style={{ cursor: "pointer" }} className="nav-link -promotion" target="_blank">
                <div className="-img-wrapper">
                  <img
                    src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24' fill='none' stroke='%23ffd54a' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2'/><circle cx='9' cy='7' r='4'/><path d='M23 21v-2a4 4 0 0 0-3-3.87'/><path d='M16 3.13a4 4 0 0 1 0 7.75'/></svg>"
                    className="-icon"
                    alt="Menu icon affiliate"
                    width={30}
                    height={30}
                  />
                </div>
                <div className="-text">พันธมิตร</div>
              </a>
            </li>
            <li className="nav-item">
              <a onClick={handleNav("/rebate")} style={{ cursor: "pointer" }} className="nav-link -promotion" target="_self">
                <div className="-img-wrapper">
                  <img
                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/c06148c6-4ac0-4345-67c7-bad06a9dfd00/public"
                    className="-icon"
                    alt="Menu icon promotion"
                    width={30}
                    height={30}
                  />
                </div>
                <div className="-text">คืนค่ายอดเสีย</div>
              </a>
            </li>
            <li className="nav-item">
              <a onClick={handleNav("/event")} style={{ cursor: "pointer" }} className="nav-link -promotion" target="_self">
                <div className="-img-wrapper">
                  <img
                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3463a213-cb98-48bc-2bdd-2b81bf3fd000/public"
                    className="-icon"
                    alt="Menu icon promotion"
                    width={30}
                    height={30}
                  />
                </div>
                <div className="-text">กิจกรรม</div>
              </a>
            </li>
            <li className="nav-item">
              <a onClick={handleNav("/event")} style={{ cursor: "pointer" }} className="nav-link -promotion" target="_self">
                <div className="-img-wrapper">
                  <img
                    src="https://cdn.javisx.com/image/7fa5a9e6-184d-4282-be20-76707d721f05.png"
                    className="-icon"
                    alt="Menu icon promotion"
                    width={30}
                    height={30}
                  />
                </div>
                <div className="-text">โปรโมชั่น</div>
              </a>
            </li>
          </ul>
          <div>
            {/**/}
            <div className="navbar-nav">
              <div className="js-ez-logged-sidebar -btn-mobile-wrapper">
                <div className="x-profile-image">
                  <a onClick={handleNav("/profile")} style={{ cursor: "pointer" }}>
                    <img

                      role="button"
                      className="img-fluid -profile-image"
                      src={"/build/rank/" + rankpic}
                      alt="customer image"
                      style={{ width: 43 }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="base-modal-overlay x-modal modal -v2 x-theme-switcher-v2 show animated animatedFadeInUp fadeInUp"
        data-v-204943c0=""
        style={{ display: modalx ? "" : "none" }}
      >
        <div className="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable modal-dialog-centered w-100 m-0"
          data-v-204943c0=""
          style={{ height: "auto" }}
        >
          <div className="modal-content -modal-content text-white" data-v-204943c0="">
            <a
              onClick={(e) => {
                setmodalx(false)
              }}
              role="button"
              className="close-model-head mt-4 mb-4"
              data-v-204943c0=""
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={30}
                height={30}
                fill="currentColor"
                className="bi bi-x-circle-fill"
                viewBox="0 0 16 16"
                data-v-204943c0=""
              >
                <path
                  d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
                  data-v-204943c0=""
                />
              </svg>
            </a>
            {/**/}
            <div className="pt-3 pb-4 x-theme-switcher-v2 text-center mt-3" data-v-204943c0="" style={{ display: loginstate == null ? "none" : (loginstate ? "" : "none") }}  >
              <div className="-inner-header-section" data-v-204943c0="">
                <img
                  src="/build/web/igame-index-lobby-wm/img/logo.png?v=1"
                  alt=""
                  data-v-204943c0=""
                  style={{ width: 260 }}
                />
              </div>
              <div className="row -inner-center-body-section m-0" data-v-204943c0="" >
                <div className="col-6 -wrapper-box" data-v-204943c0="">
                  <a
                    role="button"
                    href='/profile'
                    className="btn -btn-item -event-button -menu-center -horizontal"
                    data-v-204943c0=""
                  >
                    <picture data-v-204943c0="">
                      <source
                        type="image/webp"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e8452a1b-5ada-4f64-773f-5d87a36b9800/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e8452a1b-5ada-4f64-773f-5d87a36b9800/public"
                        data-v-204943c0=""
                      />
                      <source
                        type="image/png?v=1"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e8452a1b-5ada-4f64-773f-5d87a36b9800/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e8452a1b-5ada-4f64-773f-5d87a36b9800/public"
                        data-v-204943c0=""
                      />
                      <img
                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e8452a1b-5ada-4f64-773f-5d87a36b9800/public"
                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e8452a1b-5ada-4f64-773f-5d87a36b9800/public"
                        data-v-204943c0=""
                      />
                    </picture>
                    <div className="-typo-wrapper" data-v-204943c0="">
                      <div className="-typo -is-logged" data-v-204943c0="">
                        <span data-v-204943c0="">ข้อมูลบัญชี</span>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-6 -wrapper-box" data-v-204943c0="">
                  <a
                    role="button"
                    href='/statement'
                    className="btn -btn-item -event-button -menu-center -horizontal"
                    data-v-204943c0=""
                  >
                    <picture data-v-204943c0="">
                      <source
                        type="image/webp"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/800101be-6e7a-4619-559c-0264c03bdb00/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/800101be-6e7a-4619-559c-0264c03bdb00/public"
                        data-v-204943c0=""
                      />
                      <source
                        type="image/png?v=1"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/800101be-6e7a-4619-559c-0264c03bdb00/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/800101be-6e7a-4619-559c-0264c03bdb00/public"
                        data-v-204943c0=""
                      />
                      <img
                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/800101be-6e7a-4619-559c-0264c03bdb00/public"
                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/800101be-6e7a-4619-559c-0264c03bdb00/public"
                        data-v-204943c0=""
                      />
                    </picture>
                    <div className="-typo-wrapper" data-v-204943c0="">
                      <div className="-typo -is-logged" data-v-204943c0="">
                        <span data-v-204943c0="">ประวัติ</span>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-6 -wrapper-box" data-v-204943c0="">
                  <a
                    href='/refer/overview'
                    role="button"
                    className="btn -btn-item -event-button -menu-center -horizontal"
                    data-v-204943c0=""
                  >
                    <picture data-v-204943c0="">
                      <source
                        type="image/webp"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d03ff0f5-f6cb-440e-391f-d78cd8846000/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d03ff0f5-f6cb-440e-391f-d78cd8846000/public"
                        data-v-204943c0=""
                      />
                      <source
                        type="image/png?v=1"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d03ff0f5-f6cb-440e-391f-d78cd8846000/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d03ff0f5-f6cb-440e-391f-d78cd8846000/public"
                        data-v-204943c0=""
                      />
                      <img
                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d03ff0f5-f6cb-440e-391f-d78cd8846000/public"
                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d03ff0f5-f6cb-440e-391f-d78cd8846000/public"
                        data-v-204943c0=""
                      />
                    </picture>
                    <div className="-typo-wrapper" data-v-204943c0="">
                      <div className="-typo -is-logged" data-v-204943c0="">
                        <span data-v-204943c0="">เเนะนำเพื่อน</span>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-6 -wrapper-box" data-v-204943c0="">
                  <a
                    href='/promotion'
                    role="button"
                    className="btn -btn-item -event-button -menu-center -horizontal"
                    data-v-204943c0=""
                  >
                    <picture data-v-204943c0="">
                      <source
                        type="image/webp"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5cfc57b5-d0dc-4a6b-3823-bd521ccb6b00/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5cfc57b5-d0dc-4a6b-3823-bd521ccb6b00/public"
                        data-v-204943c0=""
                      />
                      <source
                        type="image/png?v=1"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5cfc57b5-d0dc-4a6b-3823-bd521ccb6b00/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5cfc57b5-d0dc-4a6b-3823-bd521ccb6b00/public"
                        data-v-204943c0=""
                      />
                      <img
                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5cfc57b5-d0dc-4a6b-3823-bd521ccb6b00/public"
                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5cfc57b5-d0dc-4a6b-3823-bd521ccb6b00/public"
                        data-v-204943c0=""
                      />
                    </picture>
                    <div className="-typo-wrapper" data-v-204943c0="">
                      <div className="-typo -is-logged" data-v-204943c0="">
                        <span data-v-204943c0="">โปรโมชั่น</span>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-6 -wrapper-box" data-v-204943c0="">
                  <a
                    href='/event'
                    role="button"
                    className="btn -btn-item -event-button -menu-center -horizontal"
                    data-v-204943c0=""
                  >
                    <picture data-v-204943c0="">
                      <source
                        type="image/webp"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/2edbcef7-3174-404b-8ad8-258048dea000/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/2edbcef7-3174-404b-8ad8-258048dea000/public"
                        data-v-204943c0=""
                      />
                      <source
                        type="image/png?v=1"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/2edbcef7-3174-404b-8ad8-258048dea000/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/2edbcef7-3174-404b-8ad8-258048dea000/public"
                        data-v-204943c0=""
                      />
                      <img
                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/2edbcef7-3174-404b-8ad8-258048dea000/public"
                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/2edbcef7-3174-404b-8ad8-258048dea000/public"
                        data-v-204943c0=""
                      />
                    </picture>
                    <div className="-typo-wrapper" data-v-204943c0="">
                      <div className="-typo -is-logged" data-v-204943c0="">
                        <span data-v-204943c0="">เเลกของรางวัล</span>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-6 -wrapper-box" data-v-204943c0="">
                  <a
                    href='/rebate'
                    role="button"
                    className="btn -btn-item -event-button -menu-center -horizontal"
                    data-v-204943c0=""
                  >
                    <picture data-v-204943c0="">
                      <source
                        type="image/webp"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3fe359b5-1230-42ee-cd78-fdd5a68ea800/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3fe359b5-1230-42ee-cd78-fdd5a68ea800/public"
                        data-v-204943c0=""
                      />
                      <source
                        type="image/png?v=1"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3fe359b5-1230-42ee-cd78-fdd5a68ea800/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3fe359b5-1230-42ee-cd78-fdd5a68ea800/public"
                        data-v-204943c0=""
                      />
                      <img
                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3fe359b5-1230-42ee-cd78-fdd5a68ea800/public"
                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3fe359b5-1230-42ee-cd78-fdd5a68ea800/public"
                        data-v-204943c0=""
                      />
                    </picture>
                    <div className="-typo-wrapper" data-v-204943c0="">
                      <div className="-typo -is-logged" data-v-204943c0="">
                        <span data-v-204943c0="">คืนค่าคอมมิชชั่น</span>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-6 -wrapper-box" data-v-204943c0="">
                  <a
                    href='/event'
                    role="button"
                    className="btn -btn-item -event-button -menu-center -horizontal"
                    data-v-204943c0=""
                  >
                    <picture data-v-204943c0="">
                      <source
                        type="image/webp"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/19012ba0-2564-42d2-d94a-ee8b57a0bc00/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/19012ba0-2564-42d2-d94a-ee8b57a0bc00/public"
                        data-v-204943c0=""
                      />
                      <source
                        type="image/png?v=1"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/19012ba0-2564-42d2-d94a-ee8b57a0bc00/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/19012ba0-2564-42d2-d94a-ee8b57a0bc00/public"
                        data-v-204943c0=""
                      />
                      <img
                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/19012ba0-2564-42d2-d94a-ee8b57a0bc00/public"
                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/19012ba0-2564-42d2-d94a-ee8b57a0bc00/public"
                        data-v-204943c0=""
                      />
                    </picture>
                    <div className="-typo-wrapper" data-v-204943c0="">
                      <div className="-typo -is-logged" data-v-204943c0="">
                        <span data-v-204943c0="">โบนัสเพิ่ม</span>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-6 -wrapper-box" data-v-204943c0="">
                  <a
                    href="/logout"
                    role="button"
                    className="btn -btn-item -event-button -menu-center -horizontal"
                    data-v-204943c0=""
                  >
                    <picture data-v-204943c0="">
                      <source
                        type="image/webp"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5b7096f3-1eb4-469f-0cf9-6275c441e500/public"
                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5b7096f3-1eb4-469f-0cf9-6275c441e500/public
                "
                        data-v-204943c0=""
                      />
                      <source
                        type="image/png?v=1"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5b7096f3-1eb4-469f-0cf9-6275c441e500/public"
                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5b7096f3-1eb4-469f-0cf9-6275c441e500/public
                "
                        data-v-204943c0=""
                      />
                      <img
                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5b7096f3-1eb4-469f-0cf9-6275c441e500/public"
                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5b7096f3-1eb4-469f-0cf9-6275c441e500/public"
                        data-v-204943c0=""
                      />
                    </picture>
                    <div className="-typo-wrapper" data-v-204943c0="">
                      <div className="-typo -is-logged" data-v-204943c0="">
                        ออกจากระบบ
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-12 -wrapper-box" data-v-576a2e8e="">
                  <div
                    className="btn -btn-item -line-button -menu-center -horizontal"
                    data-v-576a2e8e=""
                  >
                    <div
                      className="mt-1 mb-1 w-100"
                      data-v-576a2e8e=""
                      style={{ textAlign: "center" }}
                    >
                      <h3 className="title-footer-wrap pt-2 text-white">
                        <b>Language / ภาษา / ဘာသာစကား </b>
                      </h3>
                      <LangFlags className="-casino" />
                    </div>
                  </div>
                </div>
              </div>

              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
            </div>
            <div className="pt-3 pb-4 x-theme-switcher-v2 text-center mt-3" style={{ display: loginstate == null ? "none" : (loginstate ? "none" : "") }}data-v-204943c0="" >
              <div className="-inner-header-section" data-v-204943c0="">
                <img
                  src="/build/web/igame-index-lobby-wm/img/logo.png?v=1"
                  alt=""
                  data-v-204943c0=""
                  style={{ width: 260 }}
                />
              </div>
              <div className="row -inner-top-body-section" data-v-204943c0="">
                <div
                  className="col-6 -wrapper-box"
                  data-v-204943c0=""
                  style={{ paddingLeft: 0 }}
                >
                  <a
                    role="button"
                    href="/signin"
                    className="btn -btn-item x-transaction-button-v2 -deposit -top-btn -horizontal"

                    data-v-204943c0=""
                  >
                    <div data-v-204943c0="">
                      <img
                        alt="venis bet รูปไอคอนฝากเงิน"
                        className="img-fluid -icon-image"
                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a138dd7e-8f3a-46f9-1711-4ee9f4ac9d00/public"
                        data-v-204943c0=""
                        style={{ width: 60 }}
                      />
                    </div>
                    <div className="-typo-wrapper" data-v-204943c0="">
                      <div className="-title text-xl" data-v-204943c0="">
                        สมัครสมาชิก
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  className="col-6 -wrapper-box"
                  data-v-204943c0=""
                  style={{ paddingRight: 0 }}
                >
                  <a
                    role="button"
                    href="/register"
                    className="btn -btn-item x-transaction-button-v2 -withdraw -top-btn -horizontal"

                    data-v-204943c0=""
                  >
                    <img
                      alt=" รูปไอคอนถอนเงิน"
                      className="img-fluid -icon-image"
                      src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/99f8ec28-7c9b-42a6-a244-c647020f0700/public"
                      data-v-204943c0=""
                      style={{ width: 60 }}
                    />
                    <div className="-typo-wrapper" data-v-204943c0="">
                      <div className="-title" data-v-204943c0="">
                        เข้าสู่ระบบ
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div
                className="row justify-content-center -inner-center-body-section m-0"
                data-v-204943c0=""
              >
                <div
                  className="col-10 -wrapper-box justify-content-center"
                  data-v-204943c0=""
                >
                  <a
                    href="/promotion"
                    role="button"
                    className="btn -btn-item -promotion-button -menu-center -horizontal icon-text-wrapper"
                    data-v-204943c0=""
                  >
                    <picture data-v-204943c0="">
                      <source
                        type="image/webp"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/afcf2643-3321-4924-d4de-617d1cd9cb00/public"
                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/afcf2643-3321-4924-d4de-617d1cd9cb00/public
                "
                        data-v-204943c0=""
                      />
                      <source
                        type="image/png?v=1"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/afcf2643-3321-4924-d4de-617d1cd9cb00/public"
                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/afcf2643-3321-4924-d4de-617d1cd9cb00/public
                "
                        data-v-204943c0=""
                      />
                      <img
                        alt="รูปไอคอนโปรโมชั่น"
                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/afcf2643-3321-4924-d4de-617d1cd9cb00/public"
                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/afcf2643-3321-4924-d4de-617d1cd9cb00/public"
                        data-v-204943c0=""
                      />
                    </picture>
                    <div className="-typo-wrapper" data-v-204943c0="">
                      <div className="-typo -is-logged" data-v-204943c0="">
                        โปรโมชั่น
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-10 -wrapper-box" data-v-204943c0="">
                  <a
                    href="#" onClick={openLiveChat}
                    role="button"
                    className="btn -btn-item -line-button -menu-center -horizontal"
                    data-v-204943c0=""
                    style={{
                      backgroundImage: "unset",
                      backgroundPosition: "unset",
                      backgroundSize: "unset",
                      backgroundRepeat: "unset",
                      backgroundAttachment: "unset",
                      backgroundOrigin: "unset",
                      backgroundClip: "unset",
                      backgroundColor: "rgba(0,0,0,.25)", border: "1px solid var(--primary,#fbc844)"
                    }}
                  >
                    <img src={CHAT_ICON} alt="แชทสด" className="img-fluid -icon-image" data-v-204943c0="" />
                    <div className="-typo-wrapper" data-v-204943c0="">
                      <div className="-typo -is-logged" data-v-204943c0="">
                        {" "}
                        แชทสด{" "}
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-10 -wrapper-box" data-v-204943c0="">
                  <div
                    className="btn -btn-item -line-button -menu-center -horizontal"
                    data-v-204943c0=""
                    style={{ backgroundColor: "unset !important" }}
                  >
                    <div
                      className="mt-1 mb-1 w-100"
                      data-v-204943c0=""
                      style={{ textAlign: "center" }}
                    >
                      <h3 className="title-footer-wrap pt-2">
                        <b>Language / ภาษา / ဘာသာစကား </b>
                      </h3>
                      <LangFlags className="-casino" />
                    </div>
                  </div>
                </div>
              </div>
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
              <br data-v-204943c0="" />
            </div>
          </div>
        </div>
      </div>

    </>
  );
}


